<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'gestoesDeAulas' })"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Vínculo
        </h1>
      </v-col>
    </v-row>
    <v-card>
      <div class="pa-2">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form class="mt-2" @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
            <v-row>
              <v-col class="pt-0 pb-0" cols="12" sm="8">
                <ValidationProvider name="Professor" rules="required" v-slot="{ errors }">
                  <e-label>Professor</e-label>
                  <e-autocomplete
                    :items="professoresList"
                    :return-object="false"
                    :item-value="(value) => value.id"
                    :item-text="(val) => `${val.cpf} - ${val.nome} - ${val.user.roles[0].name}`"
                    :error-messages="errors"
                    :loading="carregandoProfessores"
                    v-model="form.instrutor_id"
                    label="Selecione uma opção"
                    dense
                    solo
                  />
                </ValidationProvider>
              </v-col>
              <v-col class="pt-0 pb-0" cols="12" sm="4">
                <ValidationProvider name="Tipo" rules="required" v-slot="{ errors }">
                  <e-label>Tipo do Professor</e-label>
                  <v-select
                    :items="tipos"
                    :item-value="(value) => value.id"
                    :item-text="(val) => val.descricao"
                    label="Selecione uma opção"
                    v-model="form.tipo_professor"
                    :error-messages="form.errors ? form.errors : errors"
                    dense
                    solo
                  ></v-select>
                </ValidationProvider>
              </v-col>
            </v-row>

            <v-row
              class="animate__animated animate__zoomIn"
              style="animation-duration: 0.5s"
              v-for="(relacao, index) of relacoes"
              :key="index"
            >
              <v-col class="pt-0 pb-0" cols="12" sm="2">
                <ValidationProvider name="Turma" rules="required" v-slot="{ errors }">
                  <e-label>Turma</e-label>
                  <e-autocomplete
                    :items="turmasList"
                    :return-object="false"
                    :item-value="(value) => value.id"
                    :item-text="(val) => val.descricao"
                    :error-messages="relacao.errors ? relacao.errors : errors"
                    :loading="carregandoTurmas"
                    v-model="relacao.turma_id"
                    :disabled="editing"
                    @change="onChangeTurma(relacao, index)"
                    label="Selecione uma opção"
                    dense
                    solo
                  />
                </ValidationProvider>
              </v-col>

              <v-col cols="12" sm="2">
                <v-container class="px-0" fluid>
                  <v-switch
                    v-model="relacao.is_polivalencia"
                    :disabled="editing"
                    label="Polivalência"
                    @change="onChangePolivalencia(relacao, index)"
                  ></v-switch>
                </v-container>
              </v-col>

              <v-col class="pt-0 pb-0" cols="12" sm="2">
                <ValidationProvider
                  name="Componente Curricular"
                  rules="required"
                  v-slot="{ errors }"
                  v-show="!relacao.is_polivalencia"
                >
                  <e-label>Componente Curricular</e-label>
                  <e-autocomplete
                    :items="relacao.disciplinasDisponiveis || []"
                    :return-object="false"
                    :item-value="(value) => value.id"
                    :item-text="(val) => val.descricao"
                    :error-messages="relacao.errors ? relacao.errors : errors"
                    :loading="relacao.carregandoDisciplinas"
                    v-model="relacao.disciplina_id"
                    :disabled="editing || !relacao.turma_id"
                    @change="() => calcularCargaHoraria(relacao, index)"
                    label="Selecione uma opção"
                    dense
                    solo
                  />
                </ValidationProvider>

                <ValidationProvider v-show="relacao.is_polivalencia" name="Componente Curricular">
                  <e-label>Componentes Curriculares</e-label>
                  <v-autocomplete
                    v-model="relacao.disciplinas_polivalencia"
                    :item-value="(value) => value.id"
                    :item-text="(val) => val.descricao"
                    :items="relacao.disciplinasDisponiveis || []"
                    :loading="relacao.carregandoDisciplinas"
                    v-show="!editing"
                    chips
                    label="Selecione os Componentes Curriculares"
                    multiple
                    solo
                    @change="() => calcularCargaHoraria(relacao, index)"
                  ></v-autocomplete>

                  <div v-show="editing" v-for="(item, idx) in relacao.disciplinas" :key="idx">
                    <v-chip x-small>{{ item.descricao }}</v-chip>
                  </div>
                </ValidationProvider>
              </v-col>

              <v-col class="pt-0 pb-0" cols="12" sm="2">
                <v-container fluid>
                  <v-checkbox
                    v-model="relacao.nao_compor_boletim_nem_ata"
                    label="Não compor BOLETIM/ATA"
                  ></v-checkbox>
                </v-container>
              </v-col>

              <v-col class="pt-0 pb-0" cols="12" sm="2">
                <ValidationProvider
                  name="Carga horária (horas)"
                  rules="required|max:5"
                  v-slot="{ errors }"
                >
                  <e-label>Carga horária (horas)</e-label>
                  <v-text-field
                    type="number"
                    v-model="relacao.carga_horaria"
                    dense
                    solo
                    :error-messages="errors"
                    readonly
                    disabled
                  />
                </ValidationProvider>
              </v-col>

              <v-col class="pt-0 pb-0" cols="12" sm="2">
                <v-container fluid>
                  <v-checkbox
                    class="pt-0 pb-0"
                    cols="1"
                    v-model="relacao.is_hp"
                    label="HP"
                  ></v-checkbox>
                </v-container>
              </v-col>

              <v-col v-if="!editing" cols="12" sm="6">
                <v-card>
                  <v-card-title style="background-color: #fbbb14">
                    <e-label>Relação de Dias e Horários</e-label>
                  </v-card-title>
                  <v-card-text class="mt-1">
                    <div v-if="relacao.horarios && relacao.horarios.length > 0">
                      <v-row>
                        <v-col cols="7" class="text-left">
                          <span class="text-uppercase">Horário</span>
                        </v-col>
                        <v-col cols="5" class="text-left">
                          <span class="text-uppercase">Dia</span>
                        </v-col>
                      </v-row>
                      <v-list>
                        <v-list-item v-for="(item, i) in relacao.horarios" :key="i">
                          <v-row>
                            <v-col cols="7" class="text-left">
                              {{ item.horario.descricao }}
                            </v-col>
                            <v-col cols="5" class="text-left">
                              {{ item.dia.descricao }}
                            </v-col>
                          </v-row>
                        </v-list-item>
                      </v-list>
                    </div>
                    <div v-else class="mt-8">
                      <p class="text-center">Não há horários selecionados</p>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col v-if="editing" cols="12" sm="3">
                <v-card>
                  <v-card-title style="background-color: #fbbb14">
                    <e-label>Relação de Dias e Horários</e-label>
                  </v-card-title>
                  <v-card-text>
                    <v-row class="mt-1">
                      <v-col cols="7" class="text-left">
                        <span class="text-uppercase">Horário</span>
                      </v-col>
                      <v-col cols="5" class="text-left">
                        <span class="text-uppercase">Dia</span>
                      </v-col>
                    </v-row>
                    <v-list>
                      <v-list-item v-for="(item, i) in relacoesDiasHorariosEdit" :key="i">
                        <v-row>
                          <v-col cols="7" class="text-left">
                            {{ item.horario.descricao }}
                          </v-col>
                          <v-col cols="5" class="text-left">
                            {{ item.dia.descricao }}
                          </v-col>
                        </v-row>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" sm="3">
                <div class="d-flex align-center">
                  <div class="mr-2">
                    <v-btn
                      color="green white--text"
                      @click="alterRelacaoIdDialog(relacao, index)"
                      style="width: 100%"
                    >
                      Dias e horários
                    </v-btn>
                  </div>
                  <div>
                    <v-btn
                      v-if="relacoes.length > 1"
                      color="error"
                      @click="() => trashRelacao(relacoes, relacao)"
                      :disabled="submittingForm"
                    >
                      <v-icon small>fa-trash</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" lg="5">
                <v-card>
                  <v-card-title>
                    <e-label>Quantidade de Aulas por etapa</e-label>
                  </v-card-title>

                  <v-card-text v-if="relacao.turma_id && relacao.etapasDisponiveis">
                    <v-row>
                      <v-col
                        cols="6"
                        v-for="etapa in relacao.etapasDisponiveis"
                        :key="etapa.id"
                        class="pa-4"
                      >
                        <ValidationProvider
                          :name="`Aulas da etapa ${etapa.descricao}`"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            type="number"
                            min="0"
                            :label="`${etapa.descricao}`"
                            v-model="relacao.relacaoAulasEtapas[etapa.id]"
                            dense
                            :error-messages="errors"
                          />
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <div v-else class="pa-4">
                    <p class="text-center">
                      <v-icon lg class="mr-2" color="primary">mdi mdi-alert</v-icon>
                      <span>Selecione uma turma primeiro!</span>
                    </p>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="d-flex justify-space-between">
                <div class="d-flex">
                  <v-btn
                    color="primary"
                    :disabled="submittingForm"
                    :loading="submittingForm"
                    type="submit"
                  >
                    Enviar Dados
                  </v-btn>
                  <v-btn
                    class="ml-3"
                    v-if="!editing"
                    color="secondary"
                    @click="adicionarRelacao"
                    :disabled="submittingForm"
                  >
                    Adicionar
                  </v-btn>
                </div>
              </v-col>
            </v-row>

            <!-- Dialog de Dias e Horários -->
            <v-dialog transition="dialog-top-transition" v-model="dialogVisible" max-width="800">
              <v-card>
                <v-toolbar color="primary" dark>
                  <div>Vinculo de dias e horários</div>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="dialogVisible = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text>
                  <v-row class="mt-4">
                    <v-col class="pt-0 pb-0" cols="4">
                      <e-label>Dias da semana</e-label>
                      <v-select
                        v-model="dia_da_semana"
                        :items="diasDaSemana"
                        :return-object="false"
                        :item-value="(value) => value"
                        :item-text="(value) => value.descricao"
                        dense
                        solo
                        label="selecione"
                      ></v-select>
                    </v-col>

                    <v-col class="pt-0 pb-0" cols="4">
                      <e-label>Horarios</e-label>
                      <v-select
                        v-model="horario_selecionado_id"
                        :items="horariosList"
                        :return-object="false"
                        :item-value="(value) => value"
                        :item-text="(value) => value.descricao"
                        dense
                        solo
                        label="selecione"
                      ></v-select>
                    </v-col>

                    <v-col class="pt-7 pb-0" cols="4">
                      <v-btn
                        :disabled="!dia_da_semana || !horario_selecionado_id"
                        color="green"
                        class="white--text"
                        @click="adicionarHorario(dialogVisibleRelacaoIndex)"
                      >
                        + adicionar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-col v-if="!editing">
                  <v-timeline
                    v-show="dialogVisibleRelacaoIndex == item.relacao_id"
                    align-top
                    dense
                    v-for="(item, i) in relacoesDiasHorarios"
                    :key="i"
                  >
                    <v-timeline-item>
                      <v-chip class="mt-1" color="green" text-color="white">
                        {{ item.dia.descricao }} | {{ item.horario.descricao }}
                      </v-chip>
                      <v-btn
                        class="ml-2"
                        @click="deleteRelacaoDiaHorario(i, dialogVisibleRelacaoIndex)"
                        color="error"
                        fab
                        small
                        dark
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-timeline-item>
                  </v-timeline>
                </v-col>
                <v-col v-if="editing">
                  <v-timeline
                    align-top
                    dense
                    v-for="(item, i) in relacoesDiasHorariosEdit"
                    :key="i"
                  >
                    <v-timeline-item>
                      <v-chip class="mt-1" color="green" text-color="white">
                        {{ item.horario.descricao }} | {{ item.dia.descricao }}
                      </v-chip>
                      <v-btn
                        class="ml-2"
                        @click="deleteRelacaoDiaHorario(i, dialogVisibleRelacaoIndex)"
                        color="error"
                        fab
                        small
                        dark
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-timeline-item>
                  </v-timeline>
                </v-col>
              </v-card>
            </v-dialog>
          </form>
        </ValidationObserver>
      </div>
    </v-card>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("Franquias", ["franquias"]),
    ...mapGetters("MainTemplate", ["menuOpen"]),
  },
  mounted() {
    this.loadData();
  },
  data() {
    return {
      msgDiasEHorariosObrigatorios: false,
      selectMultiplo: false,
      tipos: [],
      horariosList: [],
      submittingForm: false,
      professoresList: [],
      turmasList: [],
      disciplinasListGlobal: [],
      form: {},
      relacoes: [],
      carregandoProfessores: false,
      carregandoTurmas: false,
      camposObrigatoriosNaoPreenchidos: false,
      relacoesDiasHorarios: [],
      relacoesDiasHorariosEdit: [],
      horario_selecionado_id: null,
      dia_da_semana: null,
      dialogVisible: false,
      dialogVisibleRelacaoIndex: 0,
      franquiaId: 0,
      diasDaSemana: [
        { id: 0, descricao: "Segunda" },
        { id: 1, descricao: "Terça" },
        { id: 2, descricao: "Quarta" },
        { id: 3, descricao: "Quinta" },
        { id: 4, descricao: "Sexta" },
        { id: 5, descricao: "Sábado" },
      ],
    };
  },
  methods: {
    initRelacao() {
      return {
        instrutor_id: null,
        tipo_professor: null,
        turma_id: null,
        disciplina_id: null,
        disciplinas_polivalencia: [],
        is_polivalencia: false,
        nao_compor_boletim_nem_ata: false,
        is_hp: false,
        carga_horaria: 0,
        horarios: [],
        relacoesDiasHorarios: [],
        relacaoAulasEtapas: {},
        disciplinasDisponiveis: [],
        etapasDisponiveis: [],
        carregandoDisciplinas: false,
      };
    },

    async carregarDisciplinasPorTurma(relacao, index) {
      if (!relacao.turma_id) {
        this.$set(relacao, "disciplinasDisponiveis", []);
        return;
      }

      this.$set(relacao, "carregandoDisciplinas", true);
      try {
        const disciplinas = await this.$services.disciplinasService.listarDisciplinasPorTurma(
          relacao.turma_id
        );

        this.$set(relacao, "disciplinasDisponiveis", disciplinas);

        if (!this.editing) {
          this.$set(relacao, "disciplina_id", null);
          this.$set(relacao, "disciplinas_polivalencia", []);
        }

        this.calcularCargaHoraria(relacao, index);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$set(relacao, "carregandoDisciplinas", false);
      }
    },

    calcularCargaHoraria(relacao, index) {
      if (!relacao.turma_id) {
        this.$set(relacao, "carga_horaria", 0);
        return;
      }

      const turmaId = Number(relacao.turma_id);
      const turma = this.turmasList.find((t) => Number(t.id) === turmaId);
      if (!turma) {
        this.$set(relacao, "carga_horaria", 0);
        return;
      }

      let seriesIds;
      if (turma.serie_id_list?.length) {
        seriesIds = turma.serie_id_list.map(Number);
      } else if (turma.serie) {
        seriesIds = [Number(turma.serie.id)];
      } else if (turma.series?.length) {
        seriesIds = turma.series.map((s) => Number(s.id));
      } else {
        seriesIds = [];
      }

      if (!seriesIds.length) {
        this.$set(relacao, "carga_horaria", 0);
        return;
      }

      const getCargaDisciplina = (disciplina) => {
        if (!disciplina) return 0;

        let cargaTotal = 0;

        if (disciplina.series && Array.isArray(disciplina.series)) {
          cargaTotal = disciplina.series
            .filter((s) => seriesIds.includes(Number(s.id)))
            .reduce((acc, s) => {
              const cargaPivot = Number(s.pivot?.carga_horaria);
              const cargaDireta = Number(s.carga_horaria);
              const carga = !isNaN(cargaPivot) ? cargaPivot : !isNaN(cargaDireta) ? cargaDireta : 0;
              return acc + carga;
            }, 0);
        } else if (disciplina.pivot?.carga_horaria) {
          cargaTotal = Number(disciplina.pivot.carga_horaria) || 0;
        }

        return cargaTotal;
      };

      let total = 0;

      if (!relacao.is_polivalencia && relacao.disciplina_id) {
        const disciplinaId = Number(relacao.disciplina_id);
        const disciplina = relacao.disciplinasDisponiveis?.find(
          (d) => Number(d.id) === disciplinaId
        );
        total += getCargaDisciplina(disciplina);
      }

      if (relacao.is_polivalencia && relacao.disciplinas_polivalencia?.length) {
        const disciplinasUnicas = [...new Set(relacao.disciplinas_polivalencia.map(Number))];
        total += disciplinasUnicas.reduce((acc, disciplinaId) => {
          const disciplina = relacao.disciplinasDisponiveis?.find(
            (d) => Number(d.id) === disciplinaId
          );
          return acc + getCargaDisciplina(disciplina);
        }, 0);
      }

      this.$set(relacao, "carga_horaria", total);
    },

    async onChangeTurma(relacao, index) {
      await this.carregarDisciplinasPorTurma(relacao, index);
      await this.getEtapasDaTurma(relacao, index);
      await this.getHorariosDaTurma(relacao.turma_id);
      this.calcularCargaHoraria(relacao, index);
    },

    onChangePolivalencia(relacao, index) {
      if (relacao.is_polivalencia) {
        this.$set(relacao, "disciplina_id", null);
      } else {
        this.$set(relacao, "disciplinas_polivalencia", []);
      }
      this.calcularCargaHoraria(relacao, index);
    },

    trashRelacao(relacoes, relacao) {
      const index = relacoes.indexOf(relacao);
      if (index !== -1) {
        this.relacoes.splice(index, 1);
        this.$toast.success("Relação deletada com sucesso!");
      }
    },

    alterRelacaoIdDialog(relacao, index) {
      this.dia_da_semana = null;
      this.horario_selecionado_id = null;
      this.dialogVisible = true;
      this.dialogVisibleRelacaoIndex = index;
    },

    async adicionarRelacao() {
      this.dia_da_semana = null;
      this.horario_selecionado_id = null;
      this.relacoes.push(this.initRelacao());
      this.$toast.success("Nova relação adicionada!");
    },

    async adicionarHorario(relacaoIndex) {
      if (!this.dia_da_semana || !this.horario_selecionado_id) {
        this.camposObrigatoriosNaoPreenchidos = true;
        this.$toast.danger("Selecione um dia e um horário!");
        return;
      }

      const data = {
        relacao_id: relacaoIndex,
        horario: this.horario_selecionado_id,
        dia: this.dia_da_semana,
      };

      if (!this.editing) {
        this.relacoesDiasHorarios.push(data);
        if (!this.relacoes[relacaoIndex].horarios) {
          this.$set(this.relacoes[relacaoIndex], "horarios", [data]);
        } else {
          this.relacoes[relacaoIndex].horarios.push(data);
        }
      }

      if (this.editing) {
        this.relacoesDiasHorariosEdit.push(data);
      }

      this.camposObrigatoriosNaoPreenchidos = false;
      this.dia_da_semana = null;
      this.horario_selecionado_id = null;
      this.$toast.success("Horário adicionado com sucesso!");
    },

    deleteRelacaoDiaHorario(itemIndex, relacaoIndex) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar esse vínculo?",
        buttons: [
          {
            text: "Cancelar",
            callback: () => this.$modals.close(),
            props: { color: "warning", small: true },
          },
          {
            text: "Confirmar",
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando o vínculo");
              try {
                this.relacoesDiasHorarios.splice(itemIndex, 1);

                if (this.editing) {
                  this.relacoesDiasHorariosEdit.splice(itemIndex, 1);
                }

                if (this.relacoes[relacaoIndex]?.horarios) {
                  const horarioToRemove = this.relacoesDiasHorarios[itemIndex];
                  const horarioIndex = this.relacoes[relacaoIndex].horarios.findIndex(
                    (h) => h.relacao_id === horarioToRemove?.relacao_id
                  );
                  if (horarioIndex !== -1) {
                    this.relacoes[relacaoIndex].horarios.splice(horarioIndex, 1);
                  }
                }

                this.$toast.success("Vínculo deletado com sucesso");
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: { color: "error", small: true },
          },
        ],
      });
    },

    async submitForm() {
      this.submittingForm = true;

      try {
        if (this.editing) {
          const formVinculo = {
            ...this.relacoes[0],
            instrutor_id: this.form.instrutor_id,
            tipo_professor: this.form.tipo_professor,
            relacoesDiasHorarios: this.relacoesDiasHorariosEdit,
          };

          if (formVinculo.relacoesDiasHorarios.length === 0) {
            this.$toast.danger("Preencha os campos obrigatórios: Dias da semana e Horários.");
            this.submittingForm = false;
            return;
          }

          await this.$services.gestoesDeAulasService.atualizar(formVinculo);
          this.$toast.success("Vínculo atualizado com sucesso!");
          this.$router.push({ name: "gestoesDeAulas" });
        }

        if (!this.editing) {
          const formRelacoes = this.relacoes.map((relacao, index) => ({
            ...relacao,
            instrutor_id: this.form.instrutor_id,
            tipo_professor: this.form.tipo_professor,
            is_polivalencia: relacao.is_polivalencia ? 1 : 0,
            disciplina_id: relacao.is_polivalencia ? null : relacao.disciplina_id,
            relacoesDiasHorarios: this.relacoesDiasHorarios.filter((r) => r.relacao_id === index),
          }));

          if (formRelacoes.some((relacao) => relacao.relacoesDiasHorarios.length === 0)) {
            this.$toast.danger("Preencha os campos obrigatórios: Dias da semana e Horários.");
            this.submittingForm = false;
            return;
          }

          const responseData = await this.$services.gestoesDeAulasService.criar(formRelacoes);

          if (responseData.some((item) => item.errors)) {
            this.relacoes = responseData.filter((item) => item.errors);
            this.$toast.warning("Alguns vínculos precisam ser corrigidos");
          } else {
            this.$toast.success("Vínculo(s) criado(s) com sucesso!");
            this.$router.push({ name: "gestoesDeAulas" });
          }
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },

    async loadData() {
      try {
        this.$loaderService.open("Carregando dados");
        this.relacoes = [this.initRelacao()];
        this.franquiaId = this.user?.franquia?.id;

        const professoresResponse = await this.$services.professoresService.syncAllFranquia(
          this.franquiaId
        );
        this.professoresList = professoresResponse.data.professores;
        this.tipos = await this.$services.professoresService.tipos();
        this.turmasList = await this.$services.turmasService.syncAll();
        this.disciplinasListGlobal = await this.$services.disciplinasService.syncAll();
        this.horariosList = await this.$services.horariosService.syncAll();

        if (this.editing) {
          const vinculo = await this.$services.gestoesDeAulasService.gestaoGeralId(
            parseInt(this.$route.params.gestaoDeAulasId, 10)
          );

          this.relacoesDiasHorariosEdit = vinculo.relacoesDiasHorarios ?? [];
          this.form.tipo_professor = vinculo.tipo_professor;
          this.form.instrutor_id = vinculo.instrutor_id;

          vinculo.relacaoAulasEtapas = vinculo.relacaoAulasEtapas || {};
          vinculo.horarios = vinculo.relacoesDiasHorarios || [];
          vinculo.disciplinas_polivalencia = vinculo.is_polivalencia
            ? (vinculo.disciplinas || []).map((disciplina) => disciplina.id)
            : [];

          this.relacoes = [vinculo];

          if (vinculo.turma_id) {
            await this.carregarDisciplinasPorTurma(this.relacoes[0], 0);
            await this.getEtapasDaTurma(this.relacoes[0], 0);
          }

          if (vinculo.turma) {
            this.horariosList = this.horariosList.filter(
              (horario) => horario.turno_id === vinculo.turma.turno_id
            );
          }
        }

        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
        this.$loaderService.close();
      }
    },

    async getHorariosDaTurma(turma_id) {
      if (!turma_id) return;

      this.$loaderService.open("Carregando horários");
      try {
        this.horariosList = await this.$services.horariosService.getHorariosDoTurnoDaTurma(
          turma_id
        );
      } catch (error) {
        this.$toast.error("Erro ao carregar horários", error);
      } finally {
        this.$loaderService.close();
      }
    },

    async getEtapasDaTurma(relacao, index) {
      if (!relacao.turma_id) return;

      this.$loaderService.open("Carregando etapas");
      try {
        const response = await this.$services.etapasService.getEtapasBimestrais(relacao.turma_id);
        this.$set(relacao, "etapasDisponiveis", response);

        if (this.editing && index === 0) {
          response.forEach((etapa) => {
            if (!Object.prototype.hasOwnProperty.call(relacao.relacaoAulasEtapas, etapa.id)) {
              this.$set(relacao.relacaoAulasEtapas, etapa.id, "");
            }
          });
        } else if (
          !relacao.relacaoAulasEtapas ||
          Object.keys(relacao.relacaoAulasEtapas).length === 0
        ) {
          const aulasEtapas = {};
          response.forEach((etapa) => {
            aulasEtapas[etapa.id] = "";
          });
          this.$set(relacao, "relacaoAulasEtapas", aulasEtapas);
        }
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
  },
};
</script>

<style></style>
